import api from "../api"

export const SupplierImpactAPI={
	async createSupplierimpact(ConnectingTo, Importance, Year){
		let value = await api.post(`/supplierimpact/`,{
			ConnectingTo: ConnectingTo,
			Importance: Importance,
			Year: Year
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async updateSupplierimpactById(ID,Importance, Year){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.put(`/supplierimpact/${ID}`,{

			Importance: Importance,
			Year: Year
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}
}